<template>
    <modal name="terms" height="auto" scrollable adaptive>
        <app-card :title="$t('Terms and conditions')">
            <div v-if="terms" class="container text-left" v-html="terms[locale]"></div>
            <div class="text-right">
                <app-button native-type="button" @click="acceptTerms">
                    {{ $t('Accept') }}
                </app-button>
                <app-button type="outline-warning" native-type="button" @click="hide">
                    {{ $t('Cancel') }}
                </app-button>
            </div>
        </app-card>
    </modal>
</template>

<script>
import PublicPageService from '@services/publicPage.service';
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            loading: false,
            terms: null
        };
    },
    computed: {
        ...mapGetters(['locale'])
    },
    methods: {
        acceptTerms() {
            this.$emit('acceptTerms');
            this.hide();
        },
        hide() {
            this.$modal.hide('terms');
        },
        getTerms() {
            PublicPageService.publicShow('renting').then(res => {
                this.terms = res;
            });
        }
    },
    created() {
        this.getTerms();
    }
};
</script>
